// filepath: c:\Users\evict\Desktop\SpellgatherV2\web\src\components\UnderConstruction.tsx
import React from "react";
import { Link } from "react-router-dom";

const UnderConstruction: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24">
      <div className="w-full max-w-4xl flex flex-col items-center text-center space-y-10">
        {/* Image block */}
        <div className="w-full flex justify-center">
          <img
            src="/images/bob_building.png"
            alt="Under construction"
            className="max-w-[66vw] max-h-[66vh] w-auto h-auto object-contain mx-auto drop-shadow-[0_0_22px_rgba(255,200,80,0.28)]"
            loading="lazy"
            decoding="async"
          />
        </div>

        {/* Text/content block */}
        <div className="max-w-md space-y-6">
          <h1 className="text-3xl font-extrabold text-white">
            Sorry — under construction
          </h1>
          <p className="text-slate-300 leading-relaxed">
            Magic is happening behind the scenes! This page isn’t ready yet or
            something went wrong while loading it.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="px-5 py-2 rounded-md bg-amber-500 text-black font-semibold hover:bg-amber-400"
            >
              Go Home
            </Link>
            <Link
              to="/inbox"
              className="px-5 py-2 rounded-md border border-white/20 text-white hover:bg-white/10"
            >
              Inbox
            </Link>
          </div>
          <p className="text-xs text-slate-500">
            If this keeps happening, please refresh or report it.
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnderConstruction;
